// Root for the Shopify build — the only place the shop is mounted. The
// Next site used to render the same shell at /shop; that route is gone, so
// app/shop/ is now Shopify-only source. Model URLs come from
// window.__SHOP_MODELS__ (set by the section liquid to Shopify file CDN
// URLs); see modelUrl() in app/shop/products.ts.
import { createRoot } from 'react-dom/client'
import { lazy } from 'react'
import ShopShell from '../app/shop/ShopShell'

// Paint the shop controls before downloading and evaluating the 3D engine.
const ShopCanvas = lazy(() => import('../app/shop/Scene'))

const rootEl = document.getElementById('shop-3d-root')
if (rootEl) {
  createRoot(rootEl).render(<ShopShell Canvas3D={ShopCanvas} />)
}
